import lozad from 'lozad';
import 'slick-carousel/slick/slick.min.js';
import gsap from 'gsap';
import Scrollbar from 'smooth-scrollbar';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// react app
import React from 'react';
import ReactDom from 'react-dom';
import App from '../components/app';

const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
const RECIPROCAL_GR = 1 / GOLDEN_RATIO;
const DURATION = RECIPROCAL_GR;

/* eslint-disable */
// IE 11 module to enable JS to work in roots sage
if (typeof Object.assign != "function") {
  Object.assign = function (target, varArgs) {
    "use strict";
    if (target == null) {
      // TypeError if undefined or null
      throw new TypeError("Cannot convert undefined or null to object");
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) {
        // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}
/* eslint-enable */

export default {
  init() {
    // JavaScript to be fired on all pages

    // global - variables
    const navButton = document.querySelector('.burger'),
      nav = document.querySelector('.nav'),
      logo = document.querySelector('.logo'),
      body = document.querySelector('body'),
      posts = document.querySelectorAll('.posts'),
      showMore = document.querySelectorAll('.news-more'),
      accordion = document.querySelectorAll('.accordion');

    // global - burger
    navButton.addEventListener('click', function () {
      let bodyScrollBar = Scrollbar.get(document.body);
      nav.classList.toggle('block');
      navButton.classList.toggle('active');
      logo.classList.toggle('active');
      logo.classList.toggle('text-brand-blood-orange');
      body.classList.toggle('overflow-hidden');

      const isActive = navButton.classList.contains('active');

      gsap.to('#main-header', {
        duration: DURATION / 3,
        height: isActive ? '100vh' : 'auto',
        onStart: () => {
          if(isActive) {
            bodyScrollBar.updatePluginOptions('modal', { scroll: false });
          }
          else {
            bodyScrollBar.updatePluginOptions('modal', { scroll: true });
          }
        },
      });
    });

    // global - react
    if (document.getElementById('app')) {
      ReactDom.render(<App />, document.getElementById('app'));
    }

    // global - lazy loading images library
    const observer = lozad('.lazy', {
      rootMargin: '20% 0px',
    });
    observer.observe();

    // blog page - change featured image on news archive pages
    let postsCollection = Array.from(posts);

    postsCollection.forEach(function (item) {
      item.addEventListener('mouseover', function (e) {
        if (e.target.tagName === 'A') {
          item.parentNode.parentNode.querySelector('img').src =
            e.target.dataset.img;
          item.parentNode.parentNode.querySelector('.caption').innerHTML =
            e.target.dataset.caption;
        }
      });
    });

    // blog page - show more button
    let showMoreCollection = Array.from(showMore);

    showMoreCollection.forEach(function (item) {
      item.addEventListener('click', function (e) {
        const container = document.querySelector('.main-scrolling-container');
        e.preventDefault();
        let posts = this.parentNode.previousElementSibling;
        gsap.to(posts.children, {
          duration: DURATION,
          autoAlpha: 1,
          display: 'block',
          ease: 'sine.out',
          stagger: {
            each: 0.02,
            from: 'start',
          },
        });
        gsap.utils
          .toArray(item.closest('#image__sticky_container'))
          .forEach((element) => {
            let image = element.querySelector('#image__sticky');
            ScrollTrigger.create({
              end: (self) =>
                '+=' + (element.offsetHeight - self.pin.offsetHeight),
              onRefresh: (self) => (self.pin.parentNode.style.float = 'left'),
              pin: image,
              pinSpacing: false,
              scroller: container,
              scrub: true,
              start: 'top 15px',
              trigger: element,
            });
          });
        setTimeout(() => {
          ScrollTrigger.refresh();
        }, 400);
        this.remove();
      });
    });

    // news page - inital featured image
    let blogImage = Array.from(document.querySelectorAll('.blog-image'));
    let blogLink = Array.from(document.querySelectorAll('.blog-link-1'));

    blogImage.forEach(function (item, i) {
      item.src = blogLink[i].dataset.img;
    });

    // flexible content - accordion
    for (let i = 0; i < accordion.length; i++) {
      accordion[i].addEventListener('click', function () {
        this.classList.toggle('active');
        let svg = this.querySelector('svg');
        let panel = this.nextElementSibling;

        svg.classList.toggle('transform');
        svg.classList.toggle('rotate-45');
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }

    // jquery

    // homepage - slider
    $('.slider').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      infinite: true,
      pauseOnHover: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 6000,
      swipe: false,
      touchMove: false,
      variableWidth: true,
    });

    // flexible content - slider
    $('.block-slider').slick({
      appendDots: '.block-slider',
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3500,
      dots: true,
      fade: true,
      slidesToShow: 1,
      swipe: false,
    });

    // blog page - slider
    $('.news-slider').slick({
      arrows: false,
      asNavFor: '.news-slider-2',
      autoplay: true,
      autoplaySpeed: 3500,
      fade: true,
      slidesToShow: 1,
      swipe: false,
    });

    $('.news-slider-2').slick({
      appendDots: '.news-slider-2-container',
      arrows: false,
      asNavFor: '.news-slider',
      autoplaySpeed: 3500,
      dots: true,
      fade: true,
      slidesToShow: 1,
      swipe: false,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js